// signalr base
import Vue from 'vue';

const signalR = require('@microsoft/signalr');

let baseURL = '';

if (process.env.NODE_ENV !== 'development') {
  baseURL = 'wss://' + window.location.hostname + '/socketApi/menufeedhub';
  baseURL = baseURL.replace(/^https?\:\/\//i, 'ws://');
} else {
  baseURL = 'wss://' + process.env.VUE_APP_ROOT_URL.replace('https://', '').replace('http://', '') + '/socketApi/menufeedhub';
  baseURL = baseURL.replace('/api', '');
}

if (window.location.href.includes('https://engine-stg.instabet.mx')) {
  baseURL = 'wss://engine.instabet.mx/socketApi/menufeedhub';
}
if (window.location.href.includes('https://kiosk-stg.instabet.mx')) {
  baseURL = 'wss://engine-fv3.instabet.com/socketApi/menufeedhub';
}
if (window.location.href.includes('https://engine-preprod.instabet.mx')) {
  baseURL = 'wss://engine-preprod.instabet.mx/socketApi/menufeedhub';
}

const connectionStates = {
  connecting: 0,
  connected: 1,
  reconnecting: 2,
  disconnected: 4,
};

let connection;
const init = () => {
  if (connection) return;
  connection = new signalR.HubConnectionBuilder()
    .withUrl(baseURL, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      keepAliveIntervalInMilliseconds: 1000,
      serverTimeoutInMilliseconds: 10000
    })
    .configureLogging(signalR.LogLevel.Debug)
    .build();
};
const connect = onError => {
  return new Promise((resolve, reject) => {
    if (!connection) {
      init();
    }
    connection
      .start()
      .then(() => {
        resolve({
          state: connectionStates.connected,
        });

        connection.onclose(e => {
          onError();
        });

        connection.onerror(e => {
          onError();
        });
        
        connection.ondisconnected(e => {
          onError();
        });
      })
      .catch(rej => {
        reject(rej);
      });
  });
};

const disconnect = () => {
  return new Promise((resolve, reject) => {
    init();
    connection
      .stop()
      .then(res => {
        resolve({
          state: connectionStates.disconnected,
        });
      })
      .catch(rej => {
        reject(rej);
      });
  });
};

const subscribe = (method, callBack) => {
  connection.on(method, function(args) {
    callBack(args);
  });
};

const invoke = (method, args) => {
  connection.invoke(method, args);
};

const _menuSocket = {
  connect,
  subscribe,
  invoke,
  disconnect,
  connection: connection,
};

Vue.prototype.$menuSignalR = _menuSocket;

export const socket = {
  connectionStates,
  _menuSocket,
};
